/* global $, $$ */ /* Bliss */

export function tsriDropdownSetup() {
  $$('.tsri-content-dropdown').forEach(dropdown => {
    const button = $('.tsri-content-dropdown__title', dropdown)
    if (button) {
      button.addEventListener('click', event => {
        event.preventDefault()
        const content = $('.tsri-content-dropdown__content', dropdown)
        content.style.height = dropdown.classList.toggle('open')
          ? `${content.scrollHeight}px`
          : 0
      })
    }
  })
}
